import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import {
  ShipmentWaybillEditForm,
  ShipmentWaybillMainInfoFacade,
  ShipmentWaybillOverview,
  WaybillIdView,
} from '../../store';
import { ActionButtonComponent, ButtonAction, ButtonType } from '../action-button';
import { ValidationService } from '../../common';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { ChipFieldComponent } from '../chip-field';

@Component({
  imports: [
    CommonModule,
    IntrackFeatureModule,
    ReactiveFormsModule,
    TranslateModule,
    ActionButtonComponent,
    ChipFieldComponent,
  ],
  templateUrl: './shipment-waybill-main-info-edit-dialog.component.html',
  styleUrls: ['./shipment-waybill-main-info-edit-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShipmentWaybillMainInfoEditDialogComponent implements OnInit {
  editForm: FormGroup<ShipmentWaybillEditForm>;
  buttonAction = ButtonAction;
  buttonType = ButtonType;

  constructor(
    private fb: FormBuilder,
    public validationService: ValidationService,
    public dialogRef: MatDialogRef<ShipmentWaybillMainInfoEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      waybillIdView: WaybillIdView;
      waybillOverview: ShipmentWaybillOverview;
      facade: ShipmentWaybillMainInfoFacade;
    },
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  confirm(): void {
    this.data.facade.setLoadingState(false);
    this.data.facade.editWaybillMainInfo(
      this.data.waybillIdView.internalWaybillId,
      this.editForm.getRawValue(),
      this.dialogRef,
    );
  }

  closeDialog(): void {
    this.dialogRef.close(null);
  }

  private initForm(): void {
    this.editForm = this.fb.group<ShipmentWaybillEditForm>(new ShipmentWaybillEditForm(this.data.waybillOverview));
  }
}
